// localStorage helpers. Keys are namespaced to avoid clashing with anything
// else that might share this origin. Nothing here ever touches a server
// other than the backend the user explicitly points this app at.

const KEYS = {
  userToken: "sql-agent:user-token",
  adminSecret: "sql-agent:admin-secret",
  threadId: "sql-agent:thread-id",
} as const;

export function getUserToken(): string | null {
  return localStorage.getItem(KEYS.userToken);
}

export function setUserToken(token: string): void {
  localStorage.setItem(KEYS.userToken, token);
}

export function clearUserToken(): void {
  localStorage.removeItem(KEYS.userToken);
  localStorage.removeItem(KEYS.threadId); // 退出登录时同时结束会话
}

export function getAdminSecret(): string | null {
  return localStorage.getItem(KEYS.adminSecret);
}

export function setAdminSecret(secret: string): void {
  localStorage.setItem(KEYS.adminSecret, secret);
}

export function clearAdminSecret(): void {
  localStorage.removeItem(KEYS.adminSecret);
}

export function getThreadId(): string | null {
  return localStorage.getItem(KEYS.threadId);
}

export function setThreadId(threadId: string): void {
  localStorage.setItem(KEYS.threadId, threadId);
}

export function clearThreadId(): void {
  localStorage.removeItem(KEYS.threadId);
}
